module.exports = __webpack_public_path__ + "img/check-list4.6c2c8fd8.png";